import axios from './axiosConfig';

const API_URL = '/api/instructions';

const instructionService = {
    getAllInstructions: async () => {
        const response = await axios.get(API_URL);
        return response.data;
    },

    createInstruction: async (formData) => {
        const response = await axios.post(API_URL, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return response.data;
    },

    updateInstruction: async (id, formData) => {
        const response = await axios.put(`${API_URL}/${id}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return response.data;
    },

    deleteInstruction: async (id) => {
        const response = await axios.delete(`${API_URL}/${id}`);
        return response.data;
    }
};

export default instructionService;
